import React, {FunctionComponent, useContext, useEffect, useState} from 'react'
import {RootStoreContext} from "../../../app/stores/rootStore";
import {observer} from "mobx-react-lite";
import {useNavbarSelectedItem} from "../../nav/utils/index.js";
import ScheduleSectionLayout from "../../scheduleSection/layout/ScheduleSectionLayout";
import moment from "moment";
import {DATE_SERIALIZABLE_FORMAT_STRING} from "../../../app/common/util/date";
import {Button, Divider, Grid, Header, Icon, Label, Select} from "semantic-ui-react";
import CommentsSectionList from "../list/CommentsSectionList";
import {categoryFiltersCategories, IItemCategory} from "../../../app/stores/commentsSectionStore";

interface OwnProps {
}

type Props = OwnProps

const DEFAULT_START_DATE_FILTER = moment().subtract(7, 'days').format(DATE_SERIALIZABLE_FORMAT_STRING)
const DEFAULT_END_DATE_FILTER = moment().format(DATE_SERIALIZABLE_FORMAT_STRING)

const CommentsSectionDashboard: FunctionComponent<Props> = (props) => {
    const rootStore = useContext(RootStoreContext)
    const {
        setAllDateRangeParams,
        loadingAll,
        loadAll,
        setCategoryFilters,
        categoryFilter
    } = rootStore.commentsSectionStore

    const [updatedAt, setUpdatedAt] = useState('')

    useNavbarSelectedItem('commentsSection')

    useEffect(() => {
        setAllDateRangeParams(DEFAULT_START_DATE_FILTER, DEFAULT_END_DATE_FILTER, true)
        setUpdatedNow()
    }, [
        setAllDateRangeParams,
    ])

    const setUpdatedNow = () => setUpdatedAt(moment().format('DD.MM.YYYY. HH:mm:ss'))

    const handleUpdate = () => {
        setUpdatedNow()
        loadAll()
    }

    return <ScheduleSectionLayout>
        <Grid centered>
            <Divider hidden/>
            <Grid.Row centered>
                <Grid.Column textAlign='center'>
                    <Header as='h3' color='grey'>Komentari u poslednjih 7 dana
                        <Header.Subheader>
                            Ažurirano u {updatedAt}
                        </Header.Subheader>
                    </Header>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row centered>
                <Grid.Column textAlign='center'>
                    <Button
                        color='blue'
                        onClick={handleUpdate}
                        disabled={loadingAll}
                    >
                        <Icon name='sync' loading={loadingAll}/> Ažuriraj
                    </Button>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column
                    textAlign='center'
                    computer={10} tablet={12} mobile={16}
                >
                    <Select
                        placeholder='Filter'
                        clearable
                        multiple
                        renderLabel={(item, index, defaultLabelProps) => <Label
                            content={item.text}
                            color={item.color}
                        />}
                        options={categoryFiltersCategories.map(filter => ({
                            key: filter.value,
                            value: filter.value,
                            text: filter.text,
                            color: filter.color
                        }))}
                        onChange={(event, data) =>  setCategoryFilters(data.value as IItemCategory[])}
                        value={categoryFilter}
                    />
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column computer={10} tablet={12} mobile={16}>
                    {!loadingAll &&
                    <CommentsSectionList/>}
                </Grid.Column>
            </Grid.Row>
        </Grid>
    </ScheduleSectionLayout>
}

export default observer(CommentsSectionDashboard)
